import { Box } from '@mui/material';
import { PlusButton } from './addButton';
import { TitledPaper, TitledPaperProps } from '../titledPaper';

interface TitledPaperWithAddButtonProps extends TitledPaperProps {
  onClick: () => void;
}
/**
 * @summary TitledPaper with a circular AddButton at the bottom
 * @param TitledPaperWithAddButtonProps.onClick function to be called by the button's onClick
 * @see TitledPaper
 * @see PlusButton
 */
export const TitledPaperWithAddButton = (props: TitledPaperWithAddButtonProps) => {
  const { onClick, children, ...rest } = props;
  return (
    <TitledPaper {...rest}>
      {children}
      <Box display="flex" justifyContent="center" alignItems="center" padding={1}>
        <PlusButton onClick={onClick} />
      </Box>
    </TitledPaper>
  );
};
